import { useState } from 'react';
import { useAppStore, useProductStore, useReceiptStore } from 'store';
import { SCREEN_TYPES } from 'utils/constants';
import { Button } from 'components/ui/Button';
import { handleProblemResolve } from 'utils/handleProblem';
import { handleScanItemPageOpened } from '../utils';
import { ProblemScreen } from './ProblemScreen';
import { ConfirmCountdownScreen } from './ConfirmCountdownScreen';
import { UpcInputField } from './UpcInputField';

export default function ConfirmItem() {
  const [loading, setLoading] = useState(false);
  const { setCurrentScreen } = useAppStore();
  const { currentProduct: productLine, setCurrentProduct } = useProductStore();
  const { receiptData } = useReceiptStore();

  const onConfirm = () => setCurrentScreen(SCREEN_TYPES.GRADE_ITEM);
  const isUnexpected = productLine?.product_id === 'Unknown' || productLine?.expected_ind === 'n';
  const isCallback =
    productLine?.exception_process === 'callback' || productLine?.disposition_stage === 'callback';

  const handleProblem = async (): Promise<void> => {
    setLoading(true);
    const result = await handleProblemResolve(SCREEN_TYPES.CONFIRM_ITEM);
    if (!result.success) {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleScanItemPageOpened();
    setCurrentProduct(null);
  };

  const upcInput = <UpcInputField />;

  if (isCallback && productLine) {
    return (
      <ConfirmCountdownScreen
        product={productLine}
        receiptData={receiptData}
        colorKey="CALLBACK"
        title="CALLBACK"
        onConfirm={onConfirm}
        onCancel={handleCancel}
      >
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white/20 border-2 border-white text-lg font-bold text-white shadow-lg hover:bg-white/30"
          onClick={handleProblem}
          disabled={loading}
        >
          {loading ? 'Reporting...' : 'Problem'}
        </Button>
      </ConfirmCountdownScreen>
    );
  }

  if (isUnexpected) {
    return (
      <ProblemScreen
        result={{
          responseMsg: 'UNEXPECTED ITEM',
          tracking_id: receiptData?.tracking_id || receiptData?.receipt?.tracking_id,
        }}
        scanInput={upcInput}
      >
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white/20 border-2 border-white text-lg font-bold text-white shadow-lg hover:bg-white/30"
          onClick={handleProblem}
          disabled={loading}
        >
          {loading ? 'Reporting...' : 'Problem'}
        </Button>
      </ProblemScreen>
    );
  }

  if (productLine) {
    return (
      <ConfirmCountdownScreen
        product={productLine}
        receiptData={receiptData}
        onConfirm={onConfirm}
        onCancel={handleCancel}
      />
    );
  }

  return null;
}
